import ComplaintStatus from './ComplaintStatus'

export default ComplaintStatus
